import { Link } from 'react-router-dom';
import { FOOTER_ABOUT_TEXT, FOOTER_CONTACT_EMAIL, MAIN_NAV_ITEMS, SITE_URL, SOCIAL_LINKS } from '../../config';

function SocialIcon({ name }) {
  switch (name) {
    case 'facebook':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M13.5 22v-8h2.6l.4-3H13.5V9.1c0-.9.2-1.5 1.5-1.5H16.6V5.1c-.3 0-1.4-.1-2.7-.1-2.7 0-4.4 1.6-4.4 4.6V11H7v3h2.5v8h4z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm10 2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm-5 4.3A3.7 3.7 0 1 1 8.3 12 3.7 3.7 0 0 1 12 8.3zm0 2A1.7 1.7 0 1 0 13.7 12 1.7 1.7 0 0 0 12 10.3zM17.8 6.9a.9.9 0 1 1-.9-.9.9.9 0 0 1 .9.9z" />
        </svg>
      );
    case 'linkedin':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6.5 9H3.9v12h2.6V9zM5.2 3.5A1.7 1.7 0 1 0 5.2 7a1.7 1.7 0 0 0 0-3.5zM20.1 14.1c0-3.2-1.7-5.1-4.5-5.1a3.9 3.9 0 0 0-3.5 1.9V9H9.5v12h2.6v-6.4c0-1.7 1-3 2.7-3s2.6 1.2 2.6 3V21h2.7z" />
        </svg>
      );
    case 'x':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M18.9 2H22l-6.8 7.8L23 22h-6.1l-4.8-6.1L6.6 22H3.5l7.4-8.5L1 2h6.2l4.3 5.6L18.9 2zm-1.1 18h1.7L7.2 3.9H5.4L17.8 20z" />
        </svg>
      );
    case 'telegram':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M21.8 4.4 19 20.8c-.2 1.1-.8 1.4-1.6.9l-4.5-3.3-2.2 2.1c-.2.2-.4.4-.9.4l.3-5.2 9.5-8.6c.4-.4-.1-.6-.6-.3l-11.7 7.4-5-1.6c-1.1-.3-1.1-1.1.2-1.6L20.3 3.8c1-.4 1.8.2 1.5 1.6z" />
        </svg>
      );
    case 'youtube':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M21.7 7.2a3 3 0 0 0-2.1-2.1C17.7 4.6 12 4.6 12 4.6s-5.7 0-7.6.5A3 3 0 0 0 2.3 7.2 31 31 0 0 0 1.8 12a31 31 0 0 0 .5 4.8 3 3 0 0 0 2.1 2.1c1.9.5 7.6.5 7.6.5s5.7 0 7.6-.5a3 3 0 0 0 2.1-2.1 31 31 0 0 0 .5-4.8 31 31 0 0 0-.5-4.8zM10.4 15.4V8.6L16.2 12l-5.8 3.4z" />
        </svg>
      );
    case 'rss':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6.3 17.7a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM4.3 4.3v3.1a12.3 12.3 0 0 1 12.3 12.3h3.1A15.4 15.4 0 0 0 4.3 4.3zm0 6.2v3.1a6.2 6.2 0 0 1 6.2 6.2h3.1a9.3 9.3 0 0 0-9.3-9.3z" />
        </svg>
      );
    default:
      return null;
  }
}

function Footer() {
  const year = new Date().getFullYear();
  const primaryLinks = [
    { label: 'All news', to: '/news' },
    { label: 'Slots reviews', to: '/slots' },
    { label: 'Industry voices', to: '/industry-voices' },
    { label: 'Submit a tip', to: '/tips' },
  ];

  const categoryLinks = MAIN_NAV_ITEMS.filter((i) => i.category && i.category !== 'All').map((i) => ({
    label: i.label,
    to: `/news?category=${encodeURIComponent(i.category)}`,
  }));

  const visibleSocial = (Array.isArray(SOCIAL_LINKS) ? SOCIAL_LINKS : []).filter(
    (s) => s && String(s.href || '').trim()
  );

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer-shell">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo" aria-label="IGAMINGSPOT home">
              <span className="footer-logo-mark" aria-hidden="true">
                IG
              </span>
              <span className="footer-logo-text">IGAMINGSPOT</span>
            </Link>
            <div className="footer-about-title">About us</div>
            <p className="footer-about">{FOOTER_ABOUT_TEXT}</p>
            <div className="footer-contact">
              <span className="footer-contact-label">Contact us:</span>{' '}
              <a className="footer-contact-link" href={`mailto:${FOOTER_CONTACT_EMAIL}`}>
                {FOOTER_CONTACT_EMAIL}
              </a>
            </div>
          </div>

          <nav className="footer-nav" aria-label="SEO navigation">
            <div className="footer-nav-title">Explore</div>
            <div className="footer-nav-grid">
              <div className="footer-nav-col">
                <div className="footer-nav-heading">Pages</div>
                <ul className="footer-list">
                  {primaryLinks.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to} className="footer-link">
                        {l.label}
                      </Link>
                    </li>
                  ))}
                  <li>
                    <a className="footer-link" href={`${SITE_URL}/sitemap.xml`}>
                      Sitemap.xml
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-nav-col">
                <div className="footer-nav-heading">Categories</div>
                <ul className="footer-list">
                  {categoryLinks.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to} className="footer-link">
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </nav>

          <div className="footer-social" aria-label="Follow us">
            <div className="footer-social-title">Follow us</div>
            <div className="footer-social-grid">
              {visibleSocial.length ? (
                visibleSocial.map((s) => (
                  <a
                    key={s.key}
                    className="footer-social-btn"
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    title={s.label}
                  >
                    <SocialIcon name={s.key} />
                  </a>
                ))
              ) : (
                <div className="secondary-text">
                  Add social URLs via <strong>REACT_APP_SOCIAL_*</strong> env vars.
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-left">© {year} IGAMINGSPOT · Regulated iGaming coverage</div>
          <div className="footer-bottom-right" aria-label="Footer links">
            <Link to="/news" className="footer-bottom-link">
              News
            </Link>
            <Link to="/slots" className="footer-bottom-link">
              Slots
            </Link>
            <Link to="/industry-voices" className="footer-bottom-link">
              Industry voices
            </Link>
            <a className="footer-bottom-link" href={`${SITE_URL}/sitemap.xml`}>
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;


